function openMenuState() {
  $(".app").removeClass("small-sidebar");
  $(".toggle-sidebar i").removeClass("fa-angle-right").addClass("fa-angle-left");
  $(".profile-menu").show();
}
function closeMenuState() {
  $(".app").addClass("small-sidebar");
  $(".toggle-sidebar  i").removeClass("fa-angle-left").addClass("fa-angle-right");
  $(".profile-menu").hide();
}
$(document).on("click", ".toggle-sidebar ", function(e) {
  e.preventDefault();
  if ($(".app").hasClass("small-sidebar")) {
    openMenuState();
  } else {
    closeMenuState();
  }
});
